import { configureStore } from '@reduxjs/toolkit'
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import thunk from 'redux-thunk';

import auth from './auth';
import user from './user';
import unit from './unit';
import subject from './subject';
import meeting from './meeting';
import theme from './theme';
import general from './general';
const history = createBrowserHistory();
const routeMiddleware = routerMiddleware(history);


const store = configureStore({
    reducer: {
        auth,
        user,
        unit,
        subject,
        meeting,
        theme,
        general,
        router: connectRouter(history)

    },
    middleware: [routeMiddleware, thunk],

    devTools: true
})

export default store;